import React, { Component } from 'react';
import PageWithoutSidebars from '../Page/PageWithoutSidebars.jsx';
import EURO2020Meta from './EURO2020Meta';
import ReactDOM from 'react-dom';



export default class EURO2020 extends React.PureComponent {

  
  render() {

    return (
		<h2>EURO 2020</h2>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/EURO2020/EURO2020.jsx